import {
  call,
  put,
  select,
  takeLatest,
  takeEvery,
} from '@redux-saga/core/effects';
import { isEmpty } from 'lodash';
import {
  FETCH_GLOBAL_LIST,
  FETCH_GLOBAL_USERS,
  getGlobalCalled,
  getGlobalRecord,
  getGlobalRefresh,
  getGlobalUsersCalled,
  getGlobalUsersRecord,
  getGlobalUsersRefresh,
  setGlobalCalled,
  setGlobalRecord,
  setGlobalRefresh,
  setGlobalUserRecord,
} from '../../reducers/globalList';
import API from '../../services/api';
import { GLOBAL_LIST } from '../../utils/constants/globalList';

export function* getGlobalUsers() {
  const users = yield select(getGlobalUsersRecord);
  const refresh = yield select(getGlobalUsersRefresh);
  const called = yield select(getGlobalUsersCalled);

  if ((isEmpty(users) && !called) || refresh) {
    const data = yield call(fetchGlobalUsers);

    return data;
  }

  return users;
}

export function* getGlobalListSaga({ category }) {
  const data = yield select(getGlobalRecord, category);
  const refresh = yield select(getGlobalRefresh, category);
  const called = yield select(getGlobalCalled, category);

  if ((isEmpty(data) && !called) || refresh) {
    yield call(fetchGlobalList, { category });

    // return data;
  }

  // return data;
}

export function* fetchGlobalUsers() {
  try {
    const { data } = yield call(API.fetchGlobalUsers);
    if (data.data) {
      yield put(setGlobalUserRecord({ record: data.data, category: 'users' }));
    }

    yield put(setGlobalRefresh(false));
    yield put(setGlobalCalled({ called: true, category: 'users' }));

    return data.data;
  } catch (err) {
    yield put(setGlobalRefresh(false));
    yield put(setGlobalCalled({ called: true, category: 'users' }));
    return null;
  }
}
/* eslint-disable consistent-return */
export function* fetchGlobalList({ category }) {
  try {
    const api = GLOBAL_LIST[category].service;
    const { data } = yield call(api);
    if (data.data) {
      yield put(setGlobalRecord({ record: data.data, category }));
    }
    yield put(setGlobalRefresh(false, category));
    yield put(setGlobalCalled({ called: true, category }));

    // return data.data;
  } catch (err) {
    console.log({ err });
    yield put(setGlobalRefresh(false));
    yield put(setGlobalCalled({ called: true, category }));
    return null;
  }
}

export function* globalListSagas() {
  yield takeLatest(FETCH_GLOBAL_USERS, fetchGlobalUsers);
  yield takeEvery(FETCH_GLOBAL_LIST, fetchGlobalList); // takeEvery allows concurrent actions to be handled.
}
